export const validateEnrollPatient = (values, subscribeSettings) => {
  const errors = {};

  const { phone, street, city, state, zip, letter } = values;

  const hasFullAddress = street && city && state && zip;

  if (!phone && !street) {
    errors.phoneOrStreet = "Phone Number or Street Address is required";
  }

  if (phone) {
    const reminderOptions = [
      { key: "next_send", label: "Next Send" },
      { key: "first_call", label: "First Call" },
      { key: "second_call", label: "Second Call" },
      { key: "third_call", label: "Third Call" },
    ];

    const enabledChecks = reminderOptions.filter(
      ({ key }) => subscribeSettings[key]
    );

    const anyRemindersSelected = enabledChecks.some(({ key }) => values[key]);

    if (!anyRemindersSelected && enabledChecks.length > 0) {
      const expectedLabels = enabledChecks.map(({ label }) => label).join("/");
      errors.subscribeSetting = `${expectedLabels} is required`;
    }
  }

  if (street && !city) {
    errors.city = "City is required";
  }

  if (street && !state) {
    errors.state = "State is required";
  }

  if (street && !zip) {
    errors.zip = "Zip is required";
  }

  if (hasFullAddress && subscribeSettings.letter && !letter) {
    errors.subscribeSetting = "Letter is required when full address is present";
  }

  return errors;
};
